import { gql } from "@apollo/client";

export const FILL_REFERRAL_FORM = gql`
  mutation FillReferralForm($data: FillFormInputData!) {
    fillForm(data: $data)
  }
`;
